export default __webpack_public_path__ + "static/media/IMG_7663.328379cc.jpeg";